import tableAppBlackoutCameras from './tableAppBlackoutCameras';

export default {
  title: 'Blackout camera configuration',
  attributeName: 'blackoutCamerasConfiguration',
  createURL: 'blackoutCameras',
  getURL: 'blackoutCameras',
  updateURL: 'blackoutCameras',
  removeURL: 'blackoutCameras',
  sessionParams: ['appId'],
  idAttribute: 'contentId',
  itemName: 'cameraId',
  itemId: 'cameraId',
  tableConfig: tableAppBlackoutCameras,
};
